export default {
  letters: [],
  orgDistributedQuotes: [],
  letter: {},
  quoteDistributionItem: {},
  quoteDistributionItemDcTypes: [],
  balance: [],
  additionalQuotes: [],
  askQuotes: [],
  askedQuote: {},
  quoteDistribution: {},
  additionalBalance: {},
}
